export const ROLES = {
  ADMIN: 'ADMIN',
  SUPER_ADMIN: 'SUPER ADMIN',
  MANAGER: 'MANAGER',
}